import React from 'react';
import { isFunction } from 'lodash-es';

import type { SelectOption, SelectOptionWithGroup } from 'tea-component';

// 最大完整展示已选项内容的个数，超过该数值时，展示已选项的个数
const MAX_SHOW = 1;

const filterSelectedOptions = (
  options?: IGPSelectOptionWithGroup[] | null,
  value?: string[] | null,
): IGPSelectOptionWithGroup[] => {
  if (!Array.isArray(options) || !options.length) return [];
  if (!Array.isArray(value) || !value.length) return [];
  return options.filter((option) => option?.value && value.includes(option.value));
};

export const renderButton = (
  button?: React.ReactNode | ((selectedOption: SelectOptionWithGroup[]) => React.ReactNode),
  props?: {
    allOption?: false | SelectOption;
    options?: IGPSelectOptionWithGroup[] | null;
    value?: string[];
    showLabel?: boolean;
    showPlaceholder?: boolean;
    label?: string;
    placeholder?: string;
    optionTextRenderer?: IGPSelectOptionTextRenderer;
  },
) => {
  const {
    allOption,
    options,
    value,
    showLabel = true,
    showPlaceholder = false,
    placeholder,
    label,
    optionTextRenderer,
  } = props || {};
  if (button) return !isFunction(button) ? button : button(filterSelectedOptions(options, value));
  const optionsLength = options?.length || 0;
  const valueLength = value?.length || 0;
  const allOptionText = !allOption ? '' : allOption?.text || '';

  return (
    <div className="dbg-common-select-multiple-button">
      {showLabel && <span className="select-button-text">{label}</span>}
      {/* 一个都不选时 */}
      {!valueLength && (
        <span className="dbg-common-select-placeholder">{showPlaceholder ? placeholder : allOptionText}</span>
      )}
      {/* 全选，显示All */}
      {valueLength > 0 && valueLength === optionsLength && <span className="select-button-value">{allOptionText}</span>}
      {/* 选择数量大于MAX_SHOW时 并且 不是全选时，显示数量 */}
      {valueLength !== optionsLength && valueLength > MAX_SHOW && (
        <span className="select-button-value">{valueLength}</span>
      )}
      {/* 选择数量小于MAX_SHOW时，展示icon（可无） 和 text */}
      {valueLength !== optionsLength && !!valueLength && valueLength <= MAX_SHOW && (
        <span className="select-button-value">
          {value?.map((item, index) => {
            const option = options?.find((option) => option?.value === item);
            const { text } = option || {};
            return optionTextRenderer?.(option, { splitter: index < valueLength - 1 }) ?? text;
          })}
        </span>
      )}
    </div>
  );
};
